import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { ICreateBriefLedger } from "@shared/lib/types/briefLedger";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_LEDGER_AGGREGATION_QUERY_KEY,
  BRIEF_LEDGER_FACETS_QUERY_KEY,
  BRIEF_LEDGER_QUERY_KEY,
  BRIEF_TOTAL_AGGREGATION_QUERY_KEY,
} from "../constants";

export function useCreateBriefLedger() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreateBriefLedger) =>
      BriefService.createBriefLedger(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      ToastService.success("Brief ledger created successfully");
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_FACETS_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_LEDGER_AGGREGATION_QUERY_KEY });
      c.invalidateQueries({ queryKey: BRIEF_TOTAL_AGGREGATION_QUERY_KEY });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
